import { Slider, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";

interface ISliderControl {
  label: string;
  value: number;
  min?: number;
  max?: number;
  onChange: (value: number) => void;
  step?: number;
}

const SliderControl = ({ label, value, min, max, onChange, step }: ISliderControl) => {
  const [sliderState, setSliderState] = useState<number>(50);

  useEffect(() => {
    setSliderState(value);
  }, [value]);

  return (
    <Stack spacing={2} direction="row" alignItems="center" justifyContent="space-between" sx={{ width: "100%" }}>
      <Typography variant="text1xl500" color="dsBase.v200">
        {label}
      </Typography>
      <Stack spacing={2} direction="row" sx={(theme) => ({ width: "40%", pr: theme.spacing(2) })} alignItems="center">
        <Slider
          aria-label="Volume"
          value={sliderState}
          min={min}
          max={max}
          onChange={(e, val) => setSliderState(val as number)}
          onChangeCommitted={(event, value) => onChange(value as number)}
          step={step}
          sx={{
            "& .MuiSlider-thumb": {
              backgroundColor: "common.white",
              height: 24,
              width: 24,
            },
            "& .MuiSlider-track": {
              border: "none",
              height: 12,
              backgroundColor: "dsPrimary.v300",
            },
            "& .MuiSlider-rail": {
              backgroundColor: "dsSurface.v300",
              height: 12,
            },
          }}
        />
      </Stack>
    </Stack>
  );
};

export default SliderControl;
